import { UnitsProvider } from "hooks/units";
import { FilterProvider } from "hooks/dashFilter";
import { LaboratoriesDashProvider } from "hooks/laboratoriesDash";
import { CompaniesDashProvider } from "hooks/companiesDash";
import { DemographicDashProvider } from "hooks/demographicDash";
import { ExamDashProvider } from "hooks/examDash";

const AllDashFilteredProvider = ({children}) => {
    return (
        <UnitsProvider>
            <FilterProvider>
                <LaboratoriesDashProvider>
                    <CompaniesDashProvider>
                        <DemographicDashProvider>
                            <ExamDashProvider>
                                { children }
                            </ExamDashProvider>
                        </DemographicDashProvider>
                    </CompaniesDashProvider>
                </LaboratoriesDashProvider>
            </FilterProvider>
        </UnitsProvider>
    )
}

export default AllDashFilteredProvider;
